export default __webpack_public_path__ + "static/media/yellow_pat_cut.08948c83.png";